<template>
  <v-container fluid>
    <v-row  dense>
      <v-col cols="12">
        <!-- <DataTableMain :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"/> -->
        <DataTableMainServer :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"
        :Updatepagination="params" :on-pagination="pagePagination" :on-search="getSearchPagePagination"/>
        <ViewDetails :object="object" type="Contrato" />
        <ReportDialog :dialog2="openDialog"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import { UserSession } from '@/store/modules/config'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import ViewDetails from '@/components/ViewDetails'
import ReportDialog from '@/components/dialog/ReportDialog'
export default {
  mixins: [Permission],
  data: () => ({
    openDialog: false,
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'contrato.create-update' },
          { title: 'Reporte', icon: 'mdi-file-excel', color: 'blue-grey lighten-1', action: 'showDialogFechas', pagination: {}, code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Contrato', value: 'caracteristicas.contrato', class: 'black--text' },
          { text: 'Inicio', value: 'caracteristicas.fInicio', class: 'black--text' },
          { text: 'Fin', value: 'caracteristicas.fFinalizacion', class: 'black--text' },
          { text: 'Estatus', value: 'Status', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text', align: 'right' }
        ],
        loading: false,
        filter: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    params: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    default: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    user: {}
  }),
  components: {
    DataTableMainServer,
    ViewDetails,
    ReportDialog
  },
  mounted () {
    this.user = UserSession()
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'POSTPagination', 'GETObjects', 'PUTDisableEnableObjectService', 'DELETEObjectService']),
    ...mapMutations(['CLEAR_OBJECTS', 'SHOW_DIALOG_MAIN', 'SHOW_DIALOG_ALERT_MAIN', 'SHOW_DIALOG_REPORT', 'SEND_DATA_VIEW']),
    SuccessTableAction (item) { this[item.action](item) },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.POSTPagination({ url: router, data: this.params })
      } else { this.getUrlServices() }
    },
    // *==========*==========*==========*    Methods Table Pagination    *==========*==========*==========* \\
    pagePagination (val) {
      this.table.header.loading = true
      if (val) this.params = val
      else this.params = this.default
      this.ExecuteUrl('contrato.list-pagination')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      this.params = val
      this.ExecuteUrl('contrato.list-pagination')
      // this.pages = val
    },
    // *==========*==========*==========*==========*==========*==========*==========*==========*==========* \\
    // *==========*==========*==========*==========*==========*==========*==========*==========*==========* \\
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('contrato.list-pagination')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        form: 'process',
        with: '50%',
        title: 'Nuevo',
        body: {
          objectMain: { empresa_id: this.user.empresa_id },
          paramsDialog: {
            url: this.get_urls['contrato.execute'],
            urloption: this.get_urls['contrato.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    disableData  ({ item }) {
      const name = (item.activo === 'si') ? 'Desactivar' : 'Activar'
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'disable',
        with: '40%',
        title: `${name} Departamento`,
        body: {
          objectMain: item,
          url: this.get_urls['empresa.departamentos.up-down'],
          message: `¿Estás seguro en ${name} el registro?`,
          description: ''
        },
        confirmButtonText: `Sí, ${name}`,
        cancelButtonText: 'No, Cancelar'
      })
    },
    updateData ({ item }) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '40%',
        title: 'Editar Departamento',
        body: {
          objectMain: item,
          paramsDialog: {
            form: this.get_DepartamentosForm,
            url: this.get_urls['empresa.departamentos.create-update'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    deleteData  ({ item }) {
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'delete',
        with: '40%',
        title: 'Eliminar Departamento',
        body: {
          objectMain: item,
          url: this.get_urls['empresa.departamentos.delete'],
          message: '¿Estás seguro de eliminar el registro?',
          description: 'No podras revertir el movimiento'
        },
        confirmButtonText: 'Sí, Eliminar',
        cancelButtonText: 'No, Cancelar'
      })
    },

    toUploadDoc (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '55%',
        title: 'Cargar Documentos',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['contrato.execute'],
            urloption: this.get_urls['contrato.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item
          },
          method: 'form-data'
        }
      })
    },
    toEdit (item) {
      const caracteristicas = item.item.caracteristicas
      const data = {
        cicl: caracteristicas.cicl,
        fFallo: caracteristicas.fFallo,
        fInicio: caracteristicas.fInicio,
        fSesion: caracteristicas.fSesion,
        contrato: caracteristicas.contrato,
        fApertura: caracteristicas.fApertura,
        expediente: caracteristicas.expediente,
        num_sesion: caracteristicas.num_sesion,
        fPublicacion: caracteristicas.fPublicacion,
        folio_fiscal: caracteristicas.folio_fiscal,
        num_apertura: caracteristicas.num_apertura,
        proveedor_ids: caracteristicas.proveedor_ids,
        proveedor: caracteristicas.proveedor,
        fFinalizacion: caracteristicas.fFinalizacion,
        observaciones: caracteristicas.observaciones,
        importe_con_iva: caracteristicas.importe_con_iva,
        num_parte_junta: caracteristicas.num_parte_junta,
        objeto_contrato: caracteristicas.objeto_contrato,
        fJuntaAclaracion: caracteristicas.fJuntaAclaracion,
        area_contratante_id: caracteristicas.area_contratante_id,
        area_responsable_id: caracteristicas.area_responsable_id,
        area_solicitante_id: caracteristicas.area_solicitante_id,
        tipo_adquisicion_ids: caracteristicas.tipo_adquisicion_ids,
        monto_maximo_con_iva: caracteristicas.monto_maximo_con_iva,
        monto_maximo_sin_iva: caracteristicas.monto_maximo_sin_iva,
        tipo_adjudicacion_id: caracteristicas.tipo_adjudicacion_id,
        fuente_financiamiento_id: caracteristicas.fuente_financiamiento_id,
        monto_autorizado_con_iva: caracteristicas.monto_autorizado_con_iva,
        monto_autorizado_sin_iva: caracteristicas.monto_autorizado_sin_iva
      }
      this.item = item
      this.SHOW_DIALOG_MAIN({
        type: 'assign',
        form: 'process',
        with: '50%',
        title: 'Editar',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['contrato.execute'],
            urloption: this.get_urls['contrato.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: data
          }
        }
      })
    },
    showDialogFechas (item) {
      this.SHOW_DIALOG_REPORT({
        tittle: 'Reporte de contratos',
        urloption: this.get_urls['contrato.get-reporte'],
        type: 'xlsx'
      })
    },
    capitalizeFirstLetter (str) {
      const capitalized = str.charAt(0).toUpperCase() + str.slice(1)
      return capitalized
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects', 'get_objectPagination', 'get_dialogMain', 'get_sendDataView',
      'get_DepartamentosForm']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objectPagination (rows) {
      if (rows) {
        this.table.body.data = []
        this.table.header.loading = false
        this.table.body.data = rows.data
        this.table.body.totalData = rows.total
      }
    },
    get_sendDataView ({ name, model }) {
      if (name === 'create') {
        this.refreshData({})
      }
      this.SEND_DATA_VIEW({})
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }
}
</script>
